// @ts-ignore
import { parse } from "components/screener/v2/filters/generated/peggyParser";
import type { ParseFunction } from "components/screener/v2/filters/generated/peggyParser.generated";

export function evaluateFiltersExpression(expression: string): ReturnType<ParseFunction> {
  return (parse as ParseFunction)(expression, {});
}
